import React, { FC, memo, useMemo } from 'react';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerFiltersCounts } from '@minecraft.drawer';
import { useTranslation } from '@blocs.i18n';
import { FilterData, FiltersNameEnum } from '../../shared/types';
import { Label } from '../../shared/styles';

type Props = FilterData;

const TalentTypeAdvancedFilter: FC<Props> = memo(({ name, label }) => {
  const { t } = useTranslation();
  const { filtersCounts } = useDrawerFiltersCounts();
  const hasRepCount = filtersCounts?.hasRepresentation.find((opt) => opt.key === 'true')?.docCount || 0;
  const hasNoRepCount = filtersCounts?.hasRepresentation.find((opt) => opt.key === 'false')?.docCount || 0;
  const talentTypeOptions = useMemo(() => {
    return [
      {
        // this the key for the filter pills tooltip
        key: 'common:filtersName.representedTalent',
        // this is the translated string for the checkbox in the advanced filters
        value: FiltersNameEnum.represented,
        label: t('common:filtersName.representedWithCount', { count: hasRepCount }),
      },
      {
        // this the key for the filter pills tooltip
        key: 'common:filtersName.unrepresentedTalent',
        // this is the translated string for the checkbox in the advanced filters
        label: t('common:filtersName.unrepresentedWithCount', { count: hasNoRepCount }),
        value: FiltersNameEnum.unrepresented,
      },
    ];
  }, [t, hasRepCount, hasNoRepCount]);

  return (
    <>
      <Label>{label}</Label>
      <CheckboxListWithSearch withFormik name={name} options={talentTypeOptions} />
    </>
  );
});

export { TalentTypeAdvancedFilter };
